import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PromotionsService } from '../services';
import { getPromotionPayoutsQueryKey } from './useGetPromotionPayouts';

export const useUploadPayouts = (options = {}) => {
  const { onSuccess, onError } = options;
  const queryClient = useQueryClient();

  return useMutation({
    meta: { skipGlobalErrorToaster: true },
    mutationFn: ({ promotionId, file }) =>
      PromotionsService.uploadPayouts(promotionId, file),
    onSuccess: (data, variables) => {
      // A fresh batch was created — refresh that promotion's submission history.
      queryClient.invalidateQueries({
        queryKey: getPromotionPayoutsQueryKey(variables.promotionId),
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
